/* SYNC Beauty — seamless infinite marquees.
   1) zeroes track padding so the -50% keyframe lands exactly on one half (no jump at loop end);
   2) duplicates the half's content until it covers the viewport (no visible gap);
   3) normalises speed: every marquee runs at a calm, constant TARGET_PXPS regardless of content width
      (before this, duplicating content silently doubled the pixels-per-second speed). */
(function () {
  var TARGET_PXPS = 32; /* pixels per second — lower = slower */
  function makeSeamless(track, viewport) {
    if (!track || track.__mqDone) return;
    var halves = track.children;
    if (halves.length !== 2) return;
    track.style.paddingLeft = '0';
    var vp = (viewport || track.parentElement).clientWidth || window.innerWidth;
    var guard = 0;
    while (halves[0].scrollWidth > 20 && halves[0].scrollWidth < vp + 60 && guard < 6) {
      halves[0].innerHTML += halves[0].innerHTML;
      guard++;
    }
    if (guard > 0) halves[1].innerHTML = halves[0].innerHTML;
    var half = halves[0].scrollWidth;
    if (half > 20) {
      track.style.animationDuration = (half / TARGET_PXPS).toFixed(2) + 's';
    }
    track.__mqDone = true;
  }
  function run() {
    document.querySelectorAll('.marquee__track').forEach(function (t) { makeSeamless(t, t.closest('.marquee__viewport')); });
    document.querySelectorAll('.pp-marq__track').forEach(function (t) { makeSeamless(t, t.closest('.pp-marq')); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
  window.addEventListener('load', run);
})();
